module.exports = __webpack_public_path__ + "img/mini-012.18d4e5fe.jpg";